/**
 * Keys what we send FROM nuxt
 */
export const RedirectorIncomingKeysEnum = Object.freeze({
    LOGIN_META: 'loginMeta',
    TIP_PROFILE_MODAL: 'tipProfileModal'
});

/**
 * Keys what we send TO nuxt
 */
export const RedirectorOutgoingKeysEnum = Object.freeze({
    CONFIRM_TIP_PURCHASE: 'confirmTipPurchase',
});
